import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class PortalUserLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly portalUserId: number = 0;

    public readonly firstName: string = "";

    public readonly lastName: string = "";

    public readonly loginName: string = "";

    public readonly isAdminPortal: boolean = false;

    public readonly isAuthorised: boolean = false;

    // Client only properties / methods

    @Attributes.DisplayMember()
    public get fullName(): string {
        return `${this.firstName} ${this.lastName}`;
    }
}